import { useEffect, useState } from "react";
// @mui material components
import Card from "@mui/material/Card";
// Acromegaly React components
import MDBox from "components/MDBox";
import Swal from "sweetalert2";
import LoadingOverlay from "react-loading-overlay";
// Acromegaly React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import CallMissedOutgoingIcon from "@mui/icons-material/CallMissedOutgoing";

// Acromegaly React contexts
import { useMaterialUIController } from "context";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  ButtonGroup,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import LowPriorityIcon from "@mui/icons-material/LowPriority";

import getText from "Translator";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { displayErrorMessage } from "controllers/validation";
import { displaySuccessMessage } from "controllers/validation";
import { deleteForm } from "controllers/MenuController";
import { updatePageRowNumbers } from "controllers/MenuController";
import NewQuestion from "./components/NewQuestion";
import { getPageQuestions } from "controllers/QuestionController";
import RangeComponent from "./components/questions/RangeComponent";
import NumberComponent from "./components/questions/NumberComponent";
import MenuComponent from "./components/questions/MenuComponent";
import TextComponent from "./components/questions/TextComponent";
import LinkComponent from "./components/questions/LinkComponent";
import FlatComponent from "./components/questions/FlatComponent";
import SelectComponent from "./components/questions/SelectComponent";
import MCHComponent from "./components/questions/MCHComponent";
import AllQuestions from "./components/AllQuestions";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { updatePageQuestionRowNumbers } from "controllers/QuestionController";

let editQuestion;
let editformType;
let editText;
let formId;
let editisSecretary = false;
function PageQuestions(props) {
  const [controller] = useMaterialUIController();
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(new Date());

  const [questionList, setQuestionList] = useState([]);
  const [questionEdit, setQuestionEdit] = useState();
  const [open, setOpen] = useState(false);
  const [addQuestiobtnMode, setAddQuestiobtnMode] = useState("new");

  const { headline, title, capsule, form, page, formTyp } = useParams();

  const navigate = useNavigate();

  const handleDeleteFromClick = (id) => {
    Swal.fire({
      text: getText("deleteconfirm", controller.lang),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: getText("confirmButtonText", controller.lang),
      cancelButtonText: getText("cancel", controller.lang),
    }).then(async (result) => {
      if (result.value) {
        setLoading(true);
        let data = await deleteForm(controller.lang, { id }, controller.token);
        setLoading(false);
        if (data.success) {
          displaySuccessMessage(
            controller.lang,
            getText("deletesuccessful", controller.lang)
          );
          handleClose();

          getPageQuestionsDatas();
        } else {
          if (data.errorCode === 101) {
            navigate("/authentication/sign-in", { replace: true });
          } else {
            displayErrorMessage(controller.lang, data.message, data.code);
          }
        }
        setLoading(false);
      }
    });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setAddQuestiobtnMode("new");
  };
  const searchHandler = (serachParam) => {
    getPageQuestionsDatas();
  };

  const handleDropRows = async (droppedItem, pages) => {
    // Ignore drop outside droppable container
    if (!droppedItem.destination) return;
    var updatedList = [...questionList];
    // Remove dragged item
    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
    // Add dropped item
    updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
    // Update State
    updatedList.map((item, index) => {
      item.rownumber = index + 1;
    });
    await updatePageQuestionRowNumbers(
      controller.lang,
      updatedList,
      controller.token
    );

    setQuestionList(updatedList);
  };

  useEffect(() => {
    if (!title || !headline || !capsule || !form || !page) {
      navigate(-1, { replace: true });
      return;
    }
    if (!controller.authenticated) {
      navigate("/authentication/sign-in", { replace: true });
      return;
    }

    getPageQuestionsDatas();
  }, []);
  const handleOpenCondition = (typeParam, questionParam) => {
    navigate(
      `/condition/${headline}/${title}/${capsule}/${form}/${page}/${typeParam}/formType/${questionParam}`
    );
  };
  const getPageQuestionsDatas = async () => {
    try {
      setLoading(true);
      let newData = {
        lang: controller.lang,
        page,
      };

      let data = await getPageQuestions(
        controller.lang,
        newData,
        controller.token
      );
      setLoading(false);
      if (data.success) {
        console.log("data.datadata.datadata.data", data.data);
        setQuestionList(data.data);
      } else {
        displayErrorMessage(controller.lang, data.message, data.code);
      }
    } catch (err) {
      console.log(err);
      displayErrorMessage(controller.lang);
    }
  };
  const editQuestionHandle = (question) => {
    console.log("editQuestionHandle", question);
    setQuestionEdit(question);
    setAddQuestiobtnMode("edit");
  };
  const resetAddQuestiobtnMode = () => {
    setQuestionEdit();
    setAddQuestiobtnMode("new");
  };

  const renderQuestions = (item) => {
    switch (item.question.questionType) {
      case "LINK": {
        return (
          <LinkComponent
            question={item.question}
            key={item._id}
            page={page}
            form={form}
          />
        );
      }
      case "MEMO": {
        return (
          <TextComponent
            multiline={true}
            question={item.question}
            key={item._id}
            page={page}
            form={form}
          />
        );
      }
      case "TEXT": {
        return (
          <TextComponent
            multiline={false}
            question={item.question}
            key={item._id}
            page={page}
            form={form}
          />
        );
      }
      case "CALC":
      case "DATE": {
        return (
          <TextComponent
            disabled={true}
            question={item.question}
            key={item._id}
            page={page}
            form={form}
          />
        );
      }
      case "INT": {
        return (
          <NumberComponent
            question={item.question}
            key={item._id}
            page={page}
            form={form}
          />
        );
      }
      case "FLAT":
      case "FLATB": {
        return (
          <FlatComponent
            question={item.question}
            key={item._id}
            page={page}
            form={form}
          />
          // <FlatComponent
          //   question={item}
          //   index={index}
          //   key={item.id}
          //   formType={props.formType}
          //   page={props.page}
          //   form={props.form}
          //   getQuestions={getQuestions}
          //   editQuestionHandle={editQuestionHandle}
          //   copyListHandler={copyListHandler}
          // />
        );
      }
      case "SELECT":
      case "DBS": {
        return (
          <SelectComponent
            question={item.question}
            key={item._id}
            page={page}
            form={form}
          />
        );
      }
      case "RANGE": {
        return (
          <RangeComponent
            question={item.question}
            key={item._id}
            page={page}
            form={form}
          />
        );
      }
      case "TF": {
        return (
          <></>
          // <SwitchComponent
          //   question={item}
          //   index={index}
          //   key={item.id}
          //   formType={props.formType}
          //   page={props.page}
          //   form={props.form}
          //   getQuestions={getQuestions}
          //   editQuestionHandle={editQuestionHandle}
          // />
        );
      }
      case "CHECKED":
      case "MRD":
      case "DB": {
        return (
          <MCHComponent
            question={item.question}
            key={item._id}
            page={page}
            form={form}
          />
        );
      }
    }
  };
  return (
    <DashboardLayout>
      <DashboardNavbar
        title={getText("questions", controller.lang)}
        searchHandler={searchHandler}
      />
      <MDBox pb={3}>
        <LoadingOverlay
          active={loading}
          spinner
          text={getText("loading", controller.lang)}
        >
          <Grid container spacing={1}>
            <Grid item md={6} xs={12}>
              <Card>
                <ButtonGroup
                  fullWidth={true}
                  color="dark"
                  aria-label="outlined button group"
                  variant="contained"
                >
                  <Button
                    key="NewQuestiobtn"
                    style={{
                      backgroundColor:
                        addQuestiobtnMode === "new" ? "#039dfc" : "inherit",
                      color: addQuestiobtnMode === "new" ? "#FFF" : "#039dfc",
                    }}
                    onClick={async () => {
                      setAddQuestiobtnMode("new");
                      setQuestionEdit();
                    }}
                  >
                    {`New`}
                  </Button>
                  {questionEdit && (
                    <Button
                      key="EditQuestiobtn"
                      style={{
                        backgroundColor:
                          addQuestiobtnMode === "edit" ? "#039dfc" : "inherit",
                        color:
                          addQuestiobtnMode === "edit" ? "#FFF" : "#039dfc",
                      }}
                      onClick={async () => {
                        setAddQuestiobtnMode("edit");
                      }}
                    >
                      {`Edit`}
                    </Button>
                  )}
                  <Button
                    key="AddQuestiobtn"
                    style={{
                      backgroundColor:
                        addQuestiobtnMode === "add" ? "#039dfc" : "inherit",
                      color: addQuestiobtnMode === "add" ? "#FFF" : "#039dfc",
                    }}
                    onClick={async () => {
                      setAddQuestiobtnMode("add");
                      setQuestionEdit();
                    }}
                  >
                    {`Add`}
                  </Button>
                </ButtonGroup>
                <MDBox p={2}>
                  {(addQuestiobtnMode == "new" ||
                    addQuestiobtnMode == "edit") && (
                    <NewQuestion
                      page={page}
                      question={questionEdit}
                      capsule={capsule}
                      getData={getPageQuestionsDatas}
                      resetAddQuestiobtnMode={resetAddQuestiobtnMode}
                    />
                  )}
                  {addQuestiobtnMode == "add" && questionList && (
                    <AllQuestions
                      page={page}
                      capsule={capsule}
                      rownumber={questionList.length + 1}
                      getPageQuestionsDatas={getPageQuestionsDatas}
                    />
                  )}
                </MDBox>
              </Card>
            </Grid>
            <Grid item md={6} xs={12}>
              <Card style={{ maxHeight: 700, overflowY: "scroll" }}>
                {/* <ButtonGroup
                  fullWidth={true}
                  color="dark"
                  aria-label="outlined button group"
                  variant="contained"
                >
                  <Button
                    key="sendcondition"
                    style={{
                      backgroundColor: "inherit",
                      color: "#039dfc",
                    }}
                    onClick={async () => {
                      navigate(
                        `/condition/${headline}/${title}/${capsule}/${form}/${page}/coleague/coleague`
                      );
                    }}
                  >
                    <CallMissedOutgoingIcon
                      style={{ width: 20, height: 20, marginRight: 10 }}
                      color="primary"
                    />
                    {getText("sendcondition", controller.lang)}
                  </Button>
                  <Button
                    key="subformcondition"
                    style={{
                      backgroundColor: "inherit",
                      color: "#039dfc",
                    }}
                    onClick={async () => {
                      navigate(
                        `/condition/${headline}/${title}/${capsule}/${form}/${page}/subform/${formTyp}`
                      );
                    }}
                  >
                    <LowPriorityIcon
                      style={{ width: 20, height: 20, marginRight: 10 }}
                      color="primary"
                    />
                    {getText("subformcondition", controller.lang)}
                  </Button>
                </ButtonGroup> */}
                <MDBox p={2}>
                  <DragDropContext
                    style={{
                      width: "100%",
                    }}
                    onDragEnd={handleDropRows}
                  >
                    <Droppable droppableId="list-container">
                      {(provided) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                        >
                          {questionList?.map((item, index) => (
                            <Draggable
                              key={index + 100 + ""}
                              draggableId={index + 100 + ""}
                              index={index}
                            >
                              {(provided) => (
                                <Grid
                                  container
                                  key={"menu" + index + item._id}
                                  mt={1}
                                  style={{
                                    justifyContent: "flex-end",
                                  }}
                                  ref={provided.innerRef}
                                  {...provided.dragHandleProps}
                                  {...provided.draggableProps}
                                >
                                  {item.question.questionType === "LINK" && (
                                    <Grid
                                      item
                                      xs={7}
                                      sm={7}
                                      md={7}
                                      style={{
                                        justifyContent: "flex-start",
                                      }}
                                    >
                                      <div
                                        style={{
                                          width: "100%",
                                          fontSize: 13,
                                          fontWeight: "bold",
                                          color: "#039dfc",
                                        }}
                                      >
                                        {"  (Q" +
                                          item.question.questionCode +
                                          ")"}
                                      </div>
                                    </Grid>
                                  )}
                                  {item.question.questionType !== "LINK" && (
                                    <Grid
                                      item
                                      xs={7}
                                      sm={7}
                                      md={7}
                                      style={{
                                        justifyContent: "flex-start",
                                      }}
                                    >
                                      <div
                                        style={{
                                          fontSize: 13,
                                          fontWeight: "bold",
                                          color: "#039dfc",
                                        }}
                                      >
                                        {item.question.questiond.text +
                                          "  (Q" +
                                          item.question.questionCode +
                                          ")"}
                                      </div>
                                    </Grid>
                                  )}
                                  <Grid
                                    item
                                    xs={5}
                                    sm={5}
                                    md={5}
                                    style={{
                                      float:
                                        controller.direction == "rtl"
                                          ? "right"
                                          : "left",
                                    }}
                                  >
                                    <MenuComponent
                                      headline={headline}
                                      title={title}
                                      capsule={capsule}
                                      form={form}
                                      page={page}
                                      question={item}
                                      editQuestionHandle={editQuestionHandle}
                                      getQuestions={getPageQuestionsDatas}
                                      handleOpenCondition={handleOpenCondition}
                                    />
                                  </Grid>
                                  <Grid item xs={12} sm={12} md={12}>
                                    {renderQuestions(item)}
                                  </Grid>
                                </Grid>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </LoadingOverlay>
      </MDBox>
      <Dialog
        open={open}
        //onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          <HighlightOffIcon
            style={{
              width: 20,
              height: 20,
              float: controller.direction == "rtl" ? "left" : "right",
            }}
            color="primary"
            onClick={() => {
              handleClose();
            }}
          />
        </DialogTitle>
        <DialogContent></DialogContent>
      </Dialog>
    </DashboardLayout>
  );
}

export default PageQuestions;
